'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  transform: translateX(', ');\n  transition: transform 0.6s ease-in-out;\n'], ['\n  transform: translateX(', ');\n  transition: transform 0.6s ease-in-out;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SliderList = _styledComponents2.default.div(_templateObject, function (_ref) {
  var translateX = _ref.translateX;
  return translateX ? '-' + translateX + '%' : '0%';
});
exports.default = SliderList;


//////////////////
// WEBPACK FOOTER
// ./~/react-styled-carousel/build/components/SliderList.js
// module id = 436
// module chunks = 35783957827783